import { render, staticRenderFns } from "./FndPermissionDetail.vue?vue&type=template&id=78f9d86c&"
import script from "./FndPermissionDetail.vue?vue&type=script&lang=js&"
export * from "./FndPermissionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports